import React from 'react';
import { MatrixConfigurator } from './components/MatrixConfigurator';
export function App() {
  return <div className="min-h-screen w-full p-4 md:p-8" style={{
    backgroundColor: '#F5F5F5'
  }} data-id="element-0">
      <div className="mx-auto max-w-[1400px] rounded-2xl bg-white p-8 shadow-xl md:p-12" data-id="element-1">
        <div className="mb-12 text-center" data-id="element-2">
          <h1 className="mb-3 text-4xl font-bold md:text-5xl" style={{
          color: '#000000'
        }} data-id="element-3">
            Configurateur de Matrice
          </h1>
          <p className="text-base md:text-lg" style={{
          color: '#6B4423'
        }} data-id="element-4">
            Personnalisez votre marqueur d'arpentage professionnel
          </p>
        </div>
        <MatrixConfigurator data-id="element-5" />
      </div>
    </div>;
}